var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"user-card"},[_c('ProfileAvatar',{staticClass:"user-avatar",attrs:{"size":50,"avatar":_vm.user.avatar}}),_c('div',{staticClass:"user-info-box"},[_c('p',{staticClass:"user-info large"},[_vm._v(_vm._s(_vm.user.name))]),_c('p',{staticClass:"user-info small"},[_vm._v(_vm._s(_vm.user.email))])])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }